<template>
  <div v-show="isUpload">
  <div class="lenovobox_uploader_mask"></div>
  <div class="lenovobox_uploader">
    <div>
      <input type="file" multiple id="lenovobox_upload_btn" style="display: none;" size="1" @change="onChange($event)" />
      <span v-lang.upload_progress_text='[current,total]'></span>
      <div class="lenovobox_uploader_filename">{{currentUploadFilename}}</div>
      <div class="loader">
        <div class="loading" :style="'width:'+progress+'%'">
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import * as FileManager from '../../SDK/FileManager'
  import axios from 'axios'
  export default {
    props: {
      isStartUpload: {
        type: Boolean,
        required: true
      },
      postURL: {
        type: String,
        required: true
      },
      minItems: {
        type: Number,
        default: 1
      },
      maxItems: {
        type: Number,
        default: 30
      },
      method: {
        type: String,
        default: 'post'
      },
      postMeta: {
        type: [String, Array, Object],
        default: ''
      }
    },
    /*
     * The component's data.
     */
    data () {
      return {
        isUpload: false,
        isUploading: true,
        isUploaded: false,
        current: 0,
        total: 0,
        progress: 1,
        currentUploadFilename: '',
        items: [],
        itemsAdded: '',
        itemsNames: [],
        itemsSizes: [],
        formData: '',
        successMsg: '',
        errorMsg: '',
        isLoaderVisible: false
      }
    },
    methods: {
      startUploadHandle () {
        document.getElementById('lenovobox_upload_btn').click()
      },
      bytesToSize (bytes) {
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
        if (bytes === 0) return 'n/a'
        let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
        if (i === 0) return bytes + ' ' + sizes[i]
        return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i]
      },
      onChange (e) {
        this.isUpload = true
        this.successMsg = ''
        this.errorMsg = ''
        console.log('1:' + e.target.files.length)
        let files = e.target.files || e.dataTransfer.files
        let fileSizes = 0
        for (let x in files) {
          if (!isNaN(x)) {
            var params = {
              file: e.target.files[x] || e.dataTransfer.files[x],
              name: files[x].name,
              size: files[x].size
            }
            console.log(navigator.userAgent)
            if (params.name === 'image.jpg' && /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
              params.name = 'image' + new Date().getTime() + '.jpg'
            }
            fileSizes += files[x].size
            this.items.push(params)
          }
        }
        this.total = this.items.length
        this.itemsTotalSize = this.bytesToSize(fileSizes)
        console.log('upload total size:' + fileSizes)
        if (fileSizes > 1024 * 1024 * 2048) {
          this.$emit(`uploadFail`, '上传文件总大小不能超过2G')
          this.isUploading = false
          this.isUpload = false
          this.current = 0
          this.items = []
          return
        }
        console.log('upload files:' + files.length)
        if (files.length > 20) {
          this.$emit(`uploadFail`, '仅能上传不超过20个文件')
          this.isUploading = false
          this.isUpload = false
          this.current = 0
          this.items = []
          return
        }
        if (files.length === 1 && files[0].name === '/') { // 安卓手机企业微信点击上传按钮，返回后进入name为/，对于这种情况不进行上传
          this.isUploading = false
          this.isUpload = false
          this.current = 0
          this.items = []
          return
        }
        this.startUpload()
      },
      uploadProgress (oEvent) {
        let vm = this
        if (oEvent.lengthComputable) {
          let percentComplete = Math.round(oEvent.loaded * 100 / oEvent.total)
          vm.progress = percentComplete
          console.log(`percent:` + percentComplete)
        } else {
        }
      },
      /**
       * 验证权限
       * @param file
       * @param callback
       */
      checkUploadAuth (file, callback) {
        var params = {
          path: this.$store.getters.getFullPath,
          path_type: this.$store.getters.getCurrentPathType,
          bytes: file.size,
          from: this.$store.getters.getCurrentFolderInfo.from,
          prefix_neid: this.$store.getters.getCurrentFolderInfo.prefix_neid,
          iscloud: this.$store.getters.getCurrentFolderInfo.dir_type === 2 || this.$store.getters.getCurrentFolderInfo.dir_type === 4
        }
        FileManager.checkUploadAuth(params).then(response => {
          if (response.result !== 'success') {
            this.$emit(`uploadFail`, response.message)
            this.isUploading = false
            this.isUpload = false
            return
          } else {
            callback(response.region)
          }
        })
      },
      startUpload () {
        let vm = this
        if (this.isUploaded) {
          this.$emit(`uploadFail`, '网络错误')
          this.isUploading = false
          this.isUpload = false
          this.current = 0
          this.isUploaded = false
          return
        }
        if (!this.isUpload) {
          return
        }
        if (!this.items.length) {
          this.isUploading = false
          this.isUpload = false
          this.current = 0
          this.$emit(`uploadComplete`, vm.total)
          return
        }
        let file = this.items.pop()
        this.checkUploadAuth(file, function (region) {
          vm.current ++
          vm.currentUploadFilename = file.name
          vm.progress = 0
          var uploadUrl = region + vm.getUploadurl(encodeURIComponent(file.name))
          console.log(`upload url:` + uploadUrl)
          console.log(file.file)
          const form = new FormData()
          form.append('file', file.file, file.file.name)
          axios.post(uploadUrl, form, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (event) => {
              console.log(event)
            }
          }).then((res) => {
            console.log(res)
          })

          // let formData = new FormData()
          // formData.append('file', file.file)
          // var xhr = new XMLHttpRequest()
          // xhr.open(`POST`, uploadUrl)
          // xhr.onloadstart = function (e) {
          //   console.log(`start`)
          // }
          // xhr.upload.onerror = function (e) {
          //   console.log('onerror')
          //   if (e) {
          //     vm.isUploaded = true
          //   }
          // }
          // xhr.onloadend = function (e) {
          //   console.log(`finish`)
          //   vm.startUpload()
          // }
          // xhr.upload.onprogress = vm.uploadProgress
          // xhr.send(formData)
        })
      },
      getUploadurl (name) {
        console.log('test' + this.postURL.replace(`{0}`, name))
        return this.postURL.replace(`{0}`, name)
      },
      removeItems () {
        this.items = ''
        this.itemsAdded = ''
        this.itemsNames = []
        this.itemsSizes = []
        this.total = ''
      }
    },
    watch: {
      isStartUpload: function (val, oldVal) {
        console.log('isStartUpload:' + val)
        if (val === true) {
          this.startUploadHandle()
        }
      }
    },
    computed: {},
    created () {
    }
  }
</script>

<style  lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/global.styl"
  .lenovobox_uploader_mask{
    position: fixed;
    top:0px;
    left: 0px;
    width: 100%;
    height: 100%;
    opacity: 0.1;
    z-index: 11;
    background: #9c9c9c;
  }
  .lenovobox_uploader {
    position: fixed;
    margin:-25% 0px 0px -45%;
    top:50%;
    left:60%;
    z-index: 12;
    width: 70%;
    height: 3.1rem;
    opacity: 1;
    background: #fff;
    text-align: center;
    border-radius: 16px;
    font-size: 0.4rem;
    padding-top: 0.4rem;
  }

  /* End drag and drop */
  /* Loader */
  .lenovobox_uploader .loader {
    width: 86%;
    height: 8px;
    background-color: #eee;
    opacity: 1;
    position: relative;
    left: 7%;
  }
  .lenovobox_uploader .loader .loading {
    margin-top:20px;
    height: 8px;
    background-color: $primarycolor;
    border-top-left-radius: 16px;
    border-bottom-left-radius: 16px;
  }
  /* End Loader */
  .lenovobox_uploader .errorMsg {
    font-size: 2em;
    color: #a94442;
  }
  .lenovobox_uploader .successMsg {
    font-size: 2em;
    color: #3c763d;
  }
  .lenovobox_uploader_filename {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// uploader.vue?01258854